/* TUZEX posuvník veľkostí (kolekcie, vyhľadávanie, hľadanie) */
(() => {
              if (window.txSizeSlider) return; window.txSizeSlider = true;

              const init = () => document.querySelectorAll('[data-tx-sizeslider]:not([data-ready])').forEach((nav) => {
                nav.dataset.ready = '1';
                const track = nav.querySelector('[data-tx-sizeslider-track]');
                const prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]');
                const update = () => {
                  const max = track.scrollWidth - track.clientWidth - 2;
                  prev.hidden = track.scrollLeft <= 2; next.hidden = track.scrollLeft >= max;
                  nav.classList.toggle('is-start', track.scrollLeft <= 2); nav.classList.toggle('is-end', track.scrollLeft >= max);
                };
                [prev, next].forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.8, behavior: 'smooth' })));
                track.addEventListener('scroll', update, { passive: true });
                window.addEventListener('resize', update);
                const active = track.querySelector('[aria-current="true"], [aria-current="page"], input:checked');
                const activeEl = active && (active.closest('label') || active);
                if (activeEl && activeEl.offsetLeft + activeEl.offsetWidth > track.clientWidth - 8) track.scrollLeft = activeEl.offsetLeft - 40;
                update();
              });
              if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
              document.addEventListener('shopify:section:load', init);
              let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(init, 60); }).observe(document.body, { childList: true, subtree: true });
            })();
